<template>
    <popup :show="true" width="520px" @on-close="onClose">
        <div class="team-disband">
            <div class="disband-title">解散团队</div>
            <div class="disband-tips">
                解散团队将删除团队中所有数据，例如项目、文件、文件夹,且数据无法找回,请谨慎操作。
            </div>
            <div class="check-box-container">
                <div class="check-box-item">
                    <Checkbox v-model="agree"></Checkbox>我已知晓此操作不可撤销
                </div>
                <div class="check-box-item">
                    <Checkbox v-model="confirm"></Checkbox>我确认永久删除整个团队中所有数据
                </div>
            </div>
            <div class="btn-box">
                <div class="btn" @click="onClose">取消</div>
                <div class="btn" @click="onDisbandTeam">确定</div>
            </div>
        </div>
    </popup>
</template>
<script> 
import { disbandTeam } from '@/api/index';
import Popup from '@/components/Popup.vue';
export default{
    components:{
        Popup
    },
    props:{
        teamId:{
            type:[Number,String],
            default:""
        }
    },
    data(){
        return{
            team_id:'',
            agree:'',
            confirm:''
        }
    },
    mounted(){
        this.team_id = this.teamId;
    },
    methods:{
        async onDisbandTeam(){
            try{
                const {team_id,agree,confirm} = this;
                console.log('agree',agree);
                console.log('confirm',confirm);
                if(!agree){
                    this.$layer.msg('请确认知晓操作不可撤销');
                    return;
                }
                if(!confirm){
                    this.$layer.msg('请确认永久删除所有数据');
                    return;
                }
                const {code,msg} = await disbandTeam({uuid:team_id});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('团队解散成功');
                this.$emit('on-disband-success');
                this.$emit('on-close');
            }catch(e){
                console.log('err-disband-team',e);
                this.$layer.msg(e.msg);
                this.$emit('on-close',{refresh:true});
            }
        },
        onClose(){
            this.$emit('on-close');
        }
    }
}
</script>
<style lang="scss" scoped>
.team-disband{
    width:100%;
    max-height:379px;
    background:#ffffff;
    border-radius:15px;
    display:flex;
    flex-direction:column;
    padding:0 50px;
    .disband-title{
        margin-top:60px;
        color:#1a1a1a;
        font-size:24px;
        font-weight:bold;
    }
    .disband-tips{
        margin-top:19px;
        color:#666666;
        font-size:14px;
    }
    .check-box-container{
        margin-top:30px;
        display:flex;
        flex-direction:column;
        row-gap:22px;
        .check-box-item{
            color:#1a1a1a;
            font-size:14px;
            ::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
                border-color: #ff5967;
                background-color: #ff5967;
            }
            ::v-deep .ivu-checkbox-focus{
                box-shadow:none;
                -webkit-box-shadow:none;
            }
        }
    }
    .btn-box{
        width:100%;
        margin-top:40px;
        display:flex;
        justify-content:flex-end;
        column-gap:10px;
        margin-bottom:50px;
        .btn{
            width:110px;
            height:32px;
            border-radius:6px;
            background:#ffffff;
            border:1px solid #dedee0;
            line-height:32px;
            text-align:center;
            cursor:pointer;
            color:#4d4d4d;
            font-size:14px;
            &:last-child{
                color:#ffffff;
                background:#ff5967;
                border:none;
            }
        }
    }
}
</style>